import React, { useState } from 'react';

import DomainTable from '../../components/domainTable.js'
import WebsiteSecondaryPageTitle from '../../components/websiteSecondaryPageTitle.js'

import {RedirectsPageResult} from '../../../../server/routes/website.js'

interface WebsiteRedirectsPageProps { 
    server: string; 
    pageData: unknown 
}

export default function WebsiteRedirects({ server, pageData }: WebsiteRedirectsPageProps) {

	let [data, setData] = useState(pageData as RedirectsPageResult);

    // TODO: all that code below is the same for /website/* pages ... create a component out of it
    return (<>
        <WebsiteSecondaryPageTitle domainPageHeader={data.DomainPageHeader}/>
        <section className="section section-sm">
            <div className="container">
                <DomainTable 
                    domainList={data.DomainList}
                />    
            </div>
        </section>
    </>)
}
